import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SocialWallLayout } from './layouts/SocialWallLayout';
import { SocialFeedPage } from './pages/SocialFeedPage';
import { SocialDiscoverPage } from './pages/SocialDiscoverPage';
import { SocialNotificationsPage } from './pages/SocialNotificationsPage';
import { SocialProfilePage } from './pages/SocialProfilePage';
import { SocialPostPage } from './pages/SocialPostPage';
import { LoginPromptProvider } from './components/LoginPrompt';

export function SocialWallApp() {
  return (
    <LoginPromptProvider>
      <Routes>
        <Route element={<SocialWallLayout />}>
          <Route index element={<SocialFeedPage />} />
          <Route path="discover" element={<SocialDiscoverPage />} />
          <Route path="notifications" element={<SocialNotificationsPage />} />
          <Route path="profile" element={<SocialProfilePage />} />
          <Route path="post/:id" element={<SocialPostPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </LoginPromptProvider>
  );
}
